<template>
  <div v-if="!fetching">
    <div v-if="visible" class="mt-6">
      <div :class="[{ 'hidden':collapseSidebar }]" class="text-gray-800 text-xs font-bold font-['Inter'] leading-[18px]">
        <slot name="title"/>
      </div>
      <div class="mt-2 space-y-1">
        <AdminSidebarList v-for="item in options" :key="item" :type="item.type" :owner="owner" :target="item.target" :locked="item.locked ? item.locked : false" :super-user="item.super_user ? item.super_user : false">
          <template #icon>
            <div v-html="item.icon"/>
          </template>
          <template #label>{{item.label}}</template>
        </AdminSidebarList>
      </div>
    </div>
  </div>
  <div v-if="fetching">
    <div class="mt-6">
      <div :class="[{ 'hidden':collapseSidebar }]" class="text-gray-800 text-xs font-bold font-['Inter'] leading-[18px]">
        <div class="bg-gray-100 rounded-lg w-2/3 h-6"/>
      </div>
      <div class="mt-4 space-y-3">
        <div class="flex gap-3">
          <div class="bg-gray-100 rounded-lg w-6 h-6"/>
          <div class="bg-gray-100 rounded-lg w-full h-6"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
const sidebarStore = useAdminSidebarStore();
const collapseSidebar = computed(() => sidebarStore.$state.collapseSidebar);
const sessionStore = useSessionStore();
const profile = computed(() => sessionStore.$state.profile);
const visible = ref(true);
const props = defineProps({
  options: {
    type: Array,
    default: [],
  },
  owner: {
    type: String,
    default: '',
  },
});
const fetching = ref(true);
const roleData = ref(null);
const { data: roleDoc } = await useAsyncData('roleDoc', () => $fetch('/api/dashboard/role', {
    method: 'POST',
    body: {
      action: 'get-role',
      id: profile.value.roleId
    }
  }), {
  transform: (_roleDoc) => {
    return _roleDoc.result;
  },
});
roleData.value = roleDoc.value.result;
onBeforeMount(async () => {
  await checkPermissions();
  fetching.value = false;
});
const checkPermissions = async () => {
  if (props.owner !== '' && !roleData.value.permissions[props.owner].read) {
    visible.value = false;
  } else {
    visible.value = true;
  }
};
</script>

<style lang="scss" scoped>

</style>
